import { api } from "../../api";
import { loginSuccess } from "../slices/authSlice";



export const login =
  ({ email, password }) =>
  async (dispatch) => {
    try {
      const { data } = await api.post('/auth/login', {
        email,
        password,
      });
      console.log("LOGIN API RESPONSE:", data);
      const user = data.data.user;
      console.log("user", user);
      const hasPracticeManagerRole = user.roles.some(role => role.name === 'Practice Manager');
       
    
      // if (!hasPracticeManagerRole) {
      //   throw new Error('Practice Manager Does not Exist');
      // }
   
      const token = data?.data?.accessToken;
      if (token) {
        await localStorage.setItem('token', JSON.stringify(token));
      } else {
        localStorage.removeItem('token');
      }
      return dispatch(loginSuccess(data.data));
    } catch (error) {
        
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }

    throw error;
    }
  };